import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../components/buttons/Button';

export function ChatMessageInputView(props) {
  const disabled = props.disabled;
  const characterCount = props.characterCount;
  const maxLength = props.maxLength;
  return (
    <div
      className={classNames("ChatMessageInput", props.className)}
      style={props.style}
      onClick={props.onClick}
    >
      <textarea
        className="ChatMessageInput__input"
        ref={props.setInputRef}
        disabled={disabled}
        maxLength={maxLength}
        placeholder="Enter your message here"
        onKeyPress={props.onKeyPress}
        onChange={props.onChange}
      />
      <Button
        className="ChatMessageInput__button ChatMessageInput__button_callout"
        iconClass="ion-person-add"
        disabled={disabled}
        onClick={props.onCalloutButtonClick}
      />
      <Button
        className={classNames("ChatMessageInput__button ChatMessageInput__button_submit", {
          ChatMessageInput__button_valid: characterCount > 0,
        })}
        iconClass="ion-checkmark-round"
        disabled={disabled}
        onClick={props.onClickSubmit}
      />
      {characterCount < maxLength * 0.75 ? null : (
        <div className="ChatMessageInput__counter">
          <span>
            {`${characterCount}/${maxLength} characters`}
          </span>
        </div>
      )}
    </div>
  );
}

ChatMessageInputView.propTypes = {
  className: T.string,
  disabled: T.bool,
  maxLength: T.number,
  characterCount: T.number,
  setInputRef: T.func,
  onClick: T.func,
  onKeyPress: T.func,
  onChange: T.func,
  onClickSubmit: T.func,
  onCalloutButtonClick: T.func,
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatMessageInput/ChatMessageInputView.js